
const fnExists = () => {
	$.fn.exists = function (){
        return this.length > 0;
    };
}

export { fnExists }